/**
 * Store sms template module.
 *
 * @module store/templates/sms-template/module
 * @author Dilan Useche <dilan8810@gmail.com>
 * */

import actions from './sms-template.actions';

/**
 * export default
 *  @type {VuexModule}
 * */
export default {
  namespaced: true,
  actions,
};
